import React from "react";
import { Facebook, Instagram, Twitter, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#1a1311] text-[#E5E5E5] pt-20 pb-10 px-6 md:px-16 lg:px-24 border-t border-white/5">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
        {/* Brand Column */}
        <div className="space-y-6">
          <h2 className="text-2xl font-serif text-[#D4AF37] tracking-[0.1em]">
            HIRAPANNA
          </h2>
          <p className="text-[15px] leading-relaxed text-gray-400 max-w-xs">
            Since 1996, crafting timeless elegance in 18K, 22K & 24K gold and silver.
          </p>
          <div className="flex items-center gap-6 pt-2">
            <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
              <Facebook size={20} strokeWidth={1.5} />
            </a>
            <a href="https://instagram.com/hirapanna_official" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
              <Instagram size={20} strokeWidth={1.5} />
            </a>
            <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
              <Twitter size={20} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        {/* Collections Column */}
        <div>
          <h3 className="text-lg font-medium text-white mb-8 tracking-wider">Collections</h3>
          <ul className="space-y-4 text-[15px] text-gray-400">
            <li><Link to="/shop" className="hover:text-[#D4AF37] transition-colors">18K Gold</Link></li>
            <li><Link to="/shop" className="hover:text-[#D4AF37] transition-colors">22K Gold</Link></li>
            <li><Link to="/shop" className="hover:text-[#D4AF37] transition-colors">24K Gold</Link></li>
            <li><Link to="/shop" className="hover:text-[#D4AF37] transition-colors">Silver Collection</Link></li>
          </ul>
        </div>

        {/* Company Column */}
        <div>
          <h3 className="text-lg font-medium text-white mb-8 tracking-wider">Company</h3>
          <ul className="space-y-4 text-[15px] text-gray-400">
            <li><Link to="/about" className="hover:text-[#D4AF37] transition-colors">About Us</Link></li>
            <li><Link to="/heritage" className="hover:text-[#D4AF37] transition-colors">Our Heritage</Link></li>
            <li><Link to="#" className="hover:text-[#D4AF37] transition-colors">Custom Creations</Link></li>
            <li><Link to="#" className="hover:text-[#D4AF37] transition-colors">Lookbook</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37] transition-colors">Contact</Link></li>
          </ul>
        </div>

        {/* Stay Connected Column */}
        <div className="space-y-8">
          <div>
            <h3 className="text-lg font-medium text-white mb-4 tracking-wider">Stay Connected</h3>
            <p className="text-sm text-gray-400 mb-6">Subscribe for exclusive offers and new arrivals</p>
            <div className="flex items-center max-w-sm border border-gray-800 rounded-sm overflow-hidden focus-within:border-[#D4AF37] transition-colors">
              <input 
                type="email" 
                placeholder="Your email" 
                className="bg-transparent px-4 py-3 outline-none text-sm w-full placeholder:text-gray-600"
              />
              <button className="bg-[#D4AF37] text-white px-4 py-3 hover:bg-[#B8962E] transition-colors">
                <Mail size={18} />
              </button>
            </div>
          </div>
          
          <ul className="space-y-3 text-[14px] text-gray-400">
            <li><Link to="/shipping-policy" className="hover:text-[#D4AF37] transition-colors">Shipping Policy</Link></li>
            <li><Link to="/shipping-policy" className="hover:text-[#D4AF37] transition-colors">Returns & Refunds</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-[#D4AF37] transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#D4AF37] transition-colors">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-[13px] text-gray-500 tracking-wide">
        <p>© 2026 Hirapanna Jewellers. All rights reserved.</p>
        <p className="hover:text-[#D4AF37] transition-colors cursor-pointer">www.hirapannajewellers.in</p>
      </div>
    </footer>
  );
};

export default Footer;
